var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyhound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.24 28.185c-.653 6.738-.28 16.661 5.448 23.815 1.77-2.261 3.213-4.846 3.819-7.892 1.21-5.908 13.178-12.785 16.764-9.693s9.733-1.984 9.733-1.984l-6.939-5.17-.14-4.061-8.289-5.308L69.134 16l-.978 3.092 3.26 3.093c-2.888 2.354-6.986 5.03-11.13 6zm-29.963-.635c-8.096-4.72-20.472-13.445-28.102-1.621S9.48 52.438 9.48 52.438l-7.305 8.105c-.93 1.24-.93 2.956 0 4.243L13.155 84h4.793l-4.095-19.452s15.82-6.055 5.537-21.646c0 0 7.63 10.346 24.938 11.3 0 0-3.582-10.632 3.676-25.412-.14.095-9.724 3.432-17.727-1.24m29.546 28.272 2.676 12.017L74.39 79.534c7.73 0 9.613 4.466 9.613 4.466H72.756L53.084 70.417C46.246 61.071 46.642 52 52.291 52c5.65 0 7.582 3.822 7.582 3.822z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyhound);
export default __webpack_public_path__ + "static/media/greyhound.74e5c6d384ddc61a861d6e91d064f986.svg";
export { ForwardRef as ReactComponent };